var SERVICE_TYPE = 'service';
var isServiceType = function isServiceType(item) {
  return item.type === SERVICE_TYPE;
};
export default isServiceType;